<template>
    <div>
        <Header title="Allt online" subtitle="Pappersarbete enkelt i molnet" :background="header_background"/>
        <div id="mina_sidor" v-if="!mobile">
            <table>
                <tr>
                    <td>
                        <h1 class="underline">Mina Sidor</h1>
                        <p>
                            Här finner du alla uppgifter som berör dig och din tjänstgöring. <router-link to="/kontakta_oss">Kontakta oss</router-link> för att få ett konto.
                        </p>
                        <p>
                            Glömt ditt lösenord? <a href="https://b3.caspio.com/dp.asp?AppKey=78ba200030c27fc19dcd49c2816d" target="_blank">Klicka här</a>.
                        </p>
                    </td>
                    <td align="right">
                        <div class="login">
                            <h1>Inloggning</h1>
                            <p>Du skickas vidare till Caspio</p>
                            <a href="https://b3.caspio.com/dp.asp?AppKey=78ba2000f8a3b5223ba841cc9c27" target="_blank" class="button">Säker inloggning</a>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div id="mina_sidor" v-else>
            <h1 class="underline">Mina Sidor</h1>
            <p>
                Här finner du alla uppgifter som berör dig och din tjänstgöring. <router-link to="/kontakta_oss">Kontakta oss</router-link> för att få ett konto.
            </p>
            <p>
                Glömt ditt lösenord? <a href="https://b3.caspio.com/dp.asp?AppKey=78ba200030c27fc19dcd49c2816d" target="_blank">Klicka här</a>.
            </p>
            <div class="login">
                <h1>Inloggning</h1>
                <p>Du skickas vidare till Caspio</p>
                <a href="https://b3.caspio.com/dp.asp?AppKey=78ba2000f8a3b5223ba841cc9c27" target="_blank" class="button">Säker inloggning</a>
            </div>
        </div>
    </div>
</template>

<script>
import Footer from "./Footer";
import Header from "./Header";
import header_background from "../assets/img/iStock-474451428.jpg"
export default {
    components: {Footer, Header},
        data() {
            return {
                mobile: window.mobilecheck(),
                header_background: header_background
            }
        },
  name: 'MinaSidor',
  props: {
    msg: String
  }
}
</script>

<style scoped>
    @import url("../assets/css/mina_sidor.module.css");
</style>
